import React from 'react'
import './Footer.css'

const Navbar = () => {
  return (
    <div className="Footer">
        MIT © <a href="https://github.com/ipsita675" target="_blank" rel="noreferrer">Ipsita Pandey</a>
    </div>
  )
}

export default Navbar
